// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, BehaviorSubject } from 'rxjs';

// --- HS Code
import { ApplicationError, DemographicModel } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class DemographicsBaseService {
  protected _demographics$: BehaviorSubject<DemographicModel[]>;
  get demographics$(): Observable<DemographicModel[]> {
    return this._demographics$;
  }

  protected _demographicsLoading$: BehaviorSubject<boolean>;
  get demographicsLoading$(): Observable<boolean> {
    return this._demographicsLoading$;
  }

  constructor() {
    this._demographics$ = new BehaviorSubject<DemographicModel[]>(new Array<DemographicModel>());
    this._demographicsLoading$ = new BehaviorSubject<boolean>(false);
  }

  abstract loadDemographics(useCache: boolean): void;
}
